module.exports = __webpack_public_path__ + "static/media/slick-theme.f9faba67.css";